import store from "@frameworks/web/redux/store";
import { WEBINAR_DATA, WEBINAR_START_LOADER, WEBINAR_STOP_LOADER, WEBINAR_SET_ERROR, WEBINAR_HIDE_ERROR, } from "../../interfaces/Home/iWebinar";
class WebinarActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getWebinars(data) {
        this.dispatch({
            type: WEBINAR_DATA,
            payload: { data },
        });
    }
    startLoader() {
        this.dispatch({
            type: WEBINAR_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: WEBINAR_STOP_LOADER,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: WEBINAR_SET_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: WEBINAR_HIDE_ERROR,
        });
    }
}
export default WebinarActions;
